/* Copyright 2013 The MathWorks, Inc. */

define([], function () {
    return {
        DO_NOT_DISPLAY: "ToolstripDoNotDisplay",
        TAB_WIDTH: 90
    };
});